import { io } from "socket.io-client";
import Constants from "../services/constant";
const URL = Constants.SOCKET_URL;
export const socket = io(URL);
